<style lang="scss" scoped>
.media-gallery {
    width: 100%;

    img {
        object-fit: fill;
        object-position: center;
        position: absolute;
        top: 0;
        left: 0;
        width: 100%;
        height: 100%;
    }

    ::v-deep #silentbox-gallery {
        margin: 0 -8px;
        display: flex;
        flex-wrap: wrap;
    }

    ::v-deep #silentbox-overlay {
        iframe {
            width: 960px;
            height: 540px;
        }
    }

    ::v-deep .silentbox-item {
        width: 25%;
        padding: 0 8px;

        @media screen and (max-width: 1024px) {
            width: percentage(1/3);
        }

        .thumbnail {
            padding-top: 75%;
            position: relative;
            border: 1px solid #ececec;
            background-color: #ececec;
            border-radius: 4px;
            cursor: pointer;
            overflow: hidden;
        }

        .play-button {
            position: absolute;
            top: 50%;
            left: 50%;
            transform: translateX(-50%) translateY(-50%);
            width: 40px;
            height: 40px;
            background-color: #fff;
            border-radius: 50%;
            display: inline-flex;
            justify-content: center;
            align-items: center;

            svg {
                fill: #23b32f;
            }
        }

        &:first-child {
            width: 100%;

            .thumbnail {
                padding-top: 0;
                height: auto;
                margin-bottom: 16px;
                img{
                    position: relative;
                    height: auto;
                }
            }
        }

        &:nth-child(5) {
            @media screen and (max-width: 1024px) {
                display: none;
            }

            .play-button {
                display: none;
            }

            .thumbnail {
                &:before {
                    position: absolute;
                    content: "";
                    left: 0;
                    top: 0;
                    width: 100%;
                    height: 100%;
                    background-color: rgba(0, 0, 0, 0.32);
                    z-index: 2;
                }

                &:after {
                    content: "meer foto's";
                    color: #fff;
                    font-size: 12px;
                    font-weight: 700;
                    letter-spacing: 0;
                    line-height: 1.25rem;
                    text-decoration: underline;
                    position: absolute;
                    left: 0;
                    display: inline-flex;
                    justify-content: center;
                    align-items: center;
                    top: 0;
                    width: 100%;
                    height: 100%;
                    z-index: 3;
                }
            }
        }

        &:nth-child(4) {
            @media screen and (max-width: 1024px) {
                .play-button {
                    display: none;
                }

                .thumbnail {
                    &:before {
                        position: absolute;
                        content: "";
                        left: 0;
                        top: 0;
                        width: 100%;
                        height: 100%;
                        background-color: rgba(0, 0, 0, 0.32);
                        z-index: 2;
                    }

                    &:after {
                        content: "meer foto's";
                        color: #fff;
                        font-size: 0.75rem;
                        font-weight: 700;
                        letter-spacing: 0;
                        line-height: 0.9375rem;
                        text-decoration: underline;
                        position: absolute;
                        left: 0;
                        display: inline-flex;
                        justify-content: center;
                        align-items: center;
                        top: 0;
                        width: 100%;
                        height: 100%;
                        z-index: 3;
                    }
                }
            }
        }

        &:nth-child(n + 6) {
            display: none;
        }
    }
}
</style>

<template>
    <div class="media-gallery">
        <silent-box :gallery="formattedMedia" :autoplay="true">
            <template v-slot:silentbox-item="{ silentboxItem }">
                <div class="thumbnail">
                    <img v-if="silentboxItem.type === 'image'" class="lazyload" :data-src="silentboxItem.src" :alt="silentboxItem.alt">
                    <img v-if="silentboxItem.type === 'video'" class="lazyload" :data-src="silentboxItem.thumbnail" :alt="silentboxItem.alt">
                    <div v-if="silentboxItem.type === 'video'" class="play-button" v-html="svg('play')"></div>
                </div>
            </template>
        </silent-box>
    </div>
</template>

<script>
/*
import VueSilentbox from 'vue-silentbox'

Vue.use(VueSilentbox)
*/
export default {
    name: "Ui.MediaGallery",

    props: {
        media: {
            type: Array,
            required: true
        }
    },

    computed: {
        formattedMedia() {
            return this.media.map(m => ({
                type: m.type.indexOf('link') >= 0 ? 'video' : 'image',
                src: m.path,
                //alt: 'test'
            }))
        }
    }
}
</script>